import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceProcessStep } from '../../services.models';

@Component({
  selector: 'app-services-process-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './services-process-section.component.html',
  styleUrl: './services-process-section.component.scss'
})
export class ServicesProcessSectionComponent {
  @Input({ required: true }) processSteps: ServiceProcessStep[] = [];
}
